import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { CheckboxInput } from '@calendly/ui/components/checkbox-input';
import { Body, Popup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextDestructive } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useEffect, useState, forwardRef } from 'react';
const labelWrapperCss = "l1js497a";
const LabelWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelWrapperCss, props.className)} />;
});
const modalSubHeadingCss = "murxr89";
const ModalSubHeading = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(modalSubHeadingCss, props.className)} />;
});
const styledFooterCss = "sgpw4xh";
const StyledFooter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledFooterCss, props.className)} />;
});
export const MeetingIntelligenceDeleteModal = ({
  onClose,
  onConfirm,
  handleTrackModal
}) => {
  const [option1, setOption1] = useState(false);
  const [option2, setOption2] = useState(false);
  const [option3, setOption3] = useState(false);
  const [showErrorText, setShowErrorText] = useState(false);
  const allChecked = option1 && option2 && option3;
  useEffect(() => {
    if (allChecked) {
      setShowErrorText(false);
    }
  }, [option1, option2, option3, allChecked]);
  const handleConfirmValidation = () => {
    if (!allChecked) {
      setShowErrorText(true);
    } else {
      onConfirm();
      setShowErrorText(false);
    }
  };
  return <Popup onClose={() => {
    onClose();
    handleTrackModal('deleteModalDismiss', {
      action: 'dismissed'
    });
  }} title={I18n.t('publisher.account_settings.meeting_intelligence.modal.title')} withCloseButton>
      <Body>
        <ModalSubHeading>
          <BodyText>
            {I18n.t('publisher.account_settings.meeting_intelligence.modal.delete.body_text')}
          </BodyText>
        </ModalSubHeading>
        <LabelWrapper>
          <CheckboxInput checked={option1} onChange={() => setOption1(!option1)} />
          <BodyText size="medium">{I18n.t('publisher.account_settings.meeting_intelligence.modal.delete.option_1')}</BodyText>
        </LabelWrapper>
        <LabelWrapper>
          <CheckboxInput checked={option2} onChange={() => setOption2(!option2)} />
          <BodyText size="medium">{I18n.t('publisher.account_settings.meeting_intelligence.modal.delete.option_2')}</BodyText>
        </LabelWrapper>
        <LabelWrapper>
          <CheckboxInput checked={option3} onChange={() => setOption3(!option3)} />
          <BodyText size="medium">{I18n.t('publisher.account_settings.meeting_intelligence.modal.delete.option_3')}</BodyText>
        </LabelWrapper>
        {showErrorText && <BodyText size="medium" color={colorTextDestructive}>
            {I18n.t('publisher.account_settings.meeting_intelligence.modal.delete.error_info')}
          </BodyText>}
      </Body>
      <StyledFooter>
        <Button decoration="secondary-outline" onClick={() => {
        onClose();
        handleTrackModal('deleteModalDismiss', {
          action: 'cta_dismissed'
        });
      }}>
          {I18n.t('publisher.account_settings.meeting_intelligence.modal.nevermind')}
        </Button>
        <Button decoration="danger" onClick={handleConfirmValidation}>
          {I18n.t('publisher.account_settings.meeting_intelligence.modal.delete.delete_meeting_data')}
        </Button>
      </StyledFooter>
    </Popup>;
};

require("./meeting_intelligence_delete_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_intelligence_delete_modal.js");